import roleSlice from './slice/roleSlice';
import orgSlice from './slice/orgSlice';
import hotelSlice from './slice/hotelSlice';
import globalSlice from './slice/globaSlice';
import siteSlice from './slice/siteSlice';

const roleAction = roleSlice.actions;
const orgAction = orgSlice.actions;
const hotelAction = hotelSlice.actions;
const globalConfigAction = globalSlice.actions;
const siteAction = siteSlice.actions;

export { roleAction, orgAction, hotelAction, globalConfigAction, siteAction };
